export const caseSummariesLoading = ({store}) => store.caseSummariesReducer.loading;

export const caseSummariesError =  ({store})  => store.caseSummariesReducer.error;

export const caseSummariesData =  ({store})  => store.caseSummariesReducer.data;